import { FormatType } from "../../Alert/Filter/FilterType";
import {
  ConfigurationFormType,
  ConfigurationPageTables,
  ConfigurationPageType,
  ConfigurationTableFilterType,
} from "../interfaces";

const SURQUAL_SEGMENT_PAGE_SEGMENT_GROUP2_TAB: ConfigurationPageTables = {
  description: "CONF_PAGE_DESC_DEFAULT",
  type: ConfigurationPageType.TABLE,
  path: "groups-2",
  label: "SEGMENT_GROUP_2",
  model: {
    entityName: "short_name",
    label: "SEGMENT_GROUP_2",
    path: "/api/segments-groups-2",
    name: "segments_groups_2",
    attributes: [
      {
        className: "greyText",
        key: "code",
        order: 1,
        label: "CODE",
        visible: true,
      },
      {
        key: "short_name",
        order: 2,
        label: "SHORT_NAME",
        visible: true,
      },
      {
        className: "greyText",
        key: "name",
        order: 3,
        label: "LONG_NAME",
        visible: true,
      },
    ],
    filters: [
      {
        type: ConfigurationTableFilterType.Search,
      },
      {
        type: ConfigurationTableFilterType.ResetButton,
      },
    ],
    export: { path: "/api/segments-groups-2/export" },
    import: { path: "/api/segments-groups-2/presign-url" },
  },
  options: {
    formFields: [
      {
        key: "code",
        label: "CODE",
        type: ConfigurationFormType.Input,
      },
      {
        key: "short_name",
        label: "SHORT_NAME",
        type: ConfigurationFormType.Input,
      },
      {
        key: "name",
        label: "LONG_NAME",
        type: ConfigurationFormType.Input,
      },
    ],
    copyable: false,
    creatable: true,
    createOptions: [
      {
        key: "code",
        flex: "50%",
        required: true,
      },
      {
        key: "short_name",
        flex: "50%",
        required: true,
      },
      {
        key: "name",
        flex: "100%",
        required: true,
      },
    ],
    editable: true,
    editOptions: [
      {
        key: "code",
        flex: "50%",
        required: true,
      },
      {
        key: "short_name",
        flex: "50%",
        required: true,
      },
      {
        key: "name",
        flex: "100%",
        required: true,
      },
    ],
    deletable: true,
  },
};

const SURQUAL_SEGMENT_PAGE_SEGMENT_GROUP1_TAB: ConfigurationPageTables = {
  description: "CONF_PAGE_DESC_DEFAULT",
  type: ConfigurationPageType.TABLE,
  label: "SEGMENT_GROUP_1",
  path: "groups-1",
  model: {
    entityName: "short_name",
    label: "SEGMENT_GROUP_1",
    path: "/api/segments-groups-1",
    name: "segments_group1",
    attributes: [
      {
        className: "greyText",
        key: "code",
        order: 1,
        label: "CODE",
        visible: true,
      },
      {
        key: "short_name",
        order: 2,
        label: "SHORT_NAME",
        visible: true,
      },
      {
        className: "greyText separationColumnRight",
        headerClassName: "separationColumnRight",
        key: "name",
        order: 3,
        label: "LONG_NAME",
        visible: true,
      },
      {
        key: "group2.short_name",
        order: 4,
        label: "SEGMENT_GROUP_2",
        visible: true,
      },
    ],
    filters: [
      {
        type: ConfigurationTableFilterType.Search,
      },
      {
        type: ConfigurationTableFilterType.ResetButton,
      },
    ],
    export: { path: "/api/segments-groups-1/export" },
    import: { path: "/api/segments-groups-1/presign-url" },
  },
  options: {
    formFields: [
      {
        key: "code",
        label: "CODE",
        type: ConfigurationFormType.Input,
      },
      {
        key: "short_name",
        label: "SHORT_NAME",
        type: ConfigurationFormType.Input,
      },
      {
        key: "name",
        label: "LONG_NAME",
        type: ConfigurationFormType.Input,
      },
      {
        type: ConfigurationFormType.Select,
        api: "/api/segments-groups-2/",
        apiParams: {
          page_size: 100,
          ordering: "short_name",
        },
        key: "group2",
        label: "SEGMENT_GROUP_2",
        labelKey: "short_name",
        subCreationForm: SURQUAL_SEGMENT_PAGE_SEGMENT_GROUP2_TAB,
      },
      {
        key: "separatorQualification",
        label: "QUALIFICATION",
        type: ConfigurationFormType.Separator,
      },
    ],
    copyable: false,
    creatable: true,
    createOptions: [
      {
        key: "code",
        flex: "50%",
        required: true,
      },
      {
        key: "short_name",
        flex: "50%",
        required: true,
      },
      {
        key: "name",
        flex: "100%",
        required: true,
      },
      {
        key: "separatorQualification",
        flex: "100%",
      },
      {
        key: "group2",
        flex: "50%",
      },
    ],
    editable: true,
    editOptions: [
      {
        key: "code",
        flex: "50%",
        required: true,
      },
      {
        key: "short_name",
        flex: "50%",
        required: true,
      },
      {
        key: "name",
        flex: "100%",
        required: true,
      },
      {
        key: "separatorQualification",
        flex: "100%",
      },
      {
        key: "group2",
        flex: "50%",
      },
    ],
    deletable: true,
  },
};

export const SURQUAL_SEGMENT_PAGE_SEGMENT_TAB: ConfigurationPageTables = {
  type: ConfigurationPageType.TABLE,
  label: "SEGMENT",
  name: "segment",
  path: "segments",
  description: "CONF_DESC_SELFMAPPING_SEGMENT",
  model: {
    entityName: "name",
    label: "SEGMENT",
    path: "/api/segments",
    bulkPath: "/api/segments/bulk-updates",
    name: "Segment",
    attributes: [
      {
        key: "code",
        order: 1,
        label: "CODE",
        visible: true,
      },
      {
        key: "name",
        order: 2,
        label: "SEGMENT_NAME",
        visible: true,
      },
      {
        className: "greyText separationColumnRight",
        headerClassName: "separationColumnRight",
        key: "short_name",
        order: 3,
        label: "SHORT_NAME",
        visible: true,
      },
      {
        key: "properties",
        order: 4,
        label: "PROPERTIES",
        sortable: false,
        type: FormatType.LIST,
        labelKey: "short_name",
        numberOfColumnItemsToDisplay: 2,
        tooltip: true,
        visible: true,
      },
      {
        key: "nb_uh_r12",
        className: "progressOcc",
        order: 5,
        label: "OCC_SOLD",
        sortingOrder: ["desc", "asc", null],
        type: FormatType.PROGRESS,
        visible: true,
      },
      {
        key: "turnover_r12",
        className: "progressCA",
        order: 6,
        label: "CA_SOLD",
        sortingOrder: ["desc", "asc", null],
        type: FormatType.PROGRESS_CURRENCY,
        visible: true,
      },
      {
        key: "pm_r12",
        className: "progressPM",
        order: 7,
        label: "PM_SOLD",
        sortingOrder: ["desc", "asc", null],
        type: FormatType.PROGRESS_CURRENCY,
        visible: true,
      },
      {
        align: "right",
        key: "order",
        order: 8,
        label: "RANK",
        visible: true,
        type: FormatType.NUMBER,
      },
      {
        key: "group1.short_name",
        order: 9,
        label: "SEGMENT_GROUP_1",
        visible: true,
      },
      {
        key: "segment_nandc.short_name",
        order: 10,
        label: "SEGMENT_NC",
        visible: true,
      },
    ],
    filters: [
      {
        type: ConfigurationTableFilterType.SelectMultiple,
        mustTranslateOptions: false,
        api: "/api/properties/",
        apiParams: {
          page_size: 100,
          ordering: "hebergement_nom_court",
        },
        key: "properties",
        labelKey: "hebergement_nom_court",
        label: "PROPERTIES",
        lookup: "property__in",
        controlledInputSize: true,
        numericIds: true,
      },
      {
        type: ConfigurationTableFilterType.Search,
      },
      {
        type: ConfigurationTableFilterType.ResetButton,
      },
    ],
    export: { path: "/api/segments/export" },
    import: { path: "/api/segments/presign-url" },
  },
  options: {
    formFields: [
      {
        key: "code",
        label: "CODE",
        type: ConfigurationFormType.Input,
      },
      {
        key: "name",
        label: "SEGMENT_NAME",
        type: ConfigurationFormType.Input,
      },
      {
        key: "short_name",
        label: "SHORT_NAME",
        type: ConfigurationFormType.Input,
      },
      {
        type: ConfigurationFormType.Select,
        api: "/api/segments-groups-1/",
        apiParams: {
          page_size: 100,
          ordering: "short_name",
        },
        key: "group1",
        label: "SEGMENT_GROUP_1",
        labelKey: "short_name",
      },
      {
        type: ConfigurationFormType.Select,
        api: "/api/segments-nandc/",
        apiParams: {
          page_size: 100,
          ordering: "short_name",
        },
        key: "segment_nandc",
        label: "SEGMENT_NC",
        labelKey: "short_name",
      },
      {
        inputType: "integer",
        key: "order",
        label: "RANK",
        type: ConfigurationFormType.Input,
      },
      {
        key: "separatorQualification",
        label: "QUALIFICATION",
        type: ConfigurationFormType.Separator,
      },
    ],
    copyable: false,
    creatable: true,
    createOptions: [
      {
        key: "code",
        flex: "50%",
        required: true,
      },
      {
        key: "name",
        flex: "50%",
        required: true,
      },
      {
        key: "short_name",
        flex: "50%",
        required: true,
      },
      {
        key: "separatorQualification",
        flex: "100%",
      },
      {
        key: "group1",
        flex: "50%",
      },
      {
        key: "segment_nandc",
        flex: "50%",
      },
      {
        key: "order",
        flex: "100%",
        required: true,
      },
    ],
    deletable: true,
    editable: true,
    editOptions: [
      {
        key: "code",
        flex: "50%",
        required: true,
      },
      {
        key: "name",
        flex: "50%",
        required: true,
      },
      {
        key: "short_name",
        flex: "50%",
        required: true,
      },
      {
        key: "separatorQualification",
        flex: "100%",
      },
      {
        key: "group1",
        flex: "50%",
      },
      {
        key: "segment_nandc",
        flex: "50%",
      },
      {
        key: "order",
        flex: "100%",
        required: true,
      },
    ],
    rankable: {
      column: "order",
    },
  },
};

const SURQUAL_SEGMENT_PAGE_SEGMENT_NANDC_TAB: ConfigurationPageTables = {
  description: "CONF_PAGE_DESC_DEFAULT",
  type: ConfigurationPageType.TABLE,
  label: "SEGMENT_NC",
  path: "segments-nandc",
  separator: true,
  model: {
    entityName: "short_name",
    label: "SEGMENT_NC",
    path: "/api/segments-nandc",
    name: "segment_nandc",
    attributes: [
      {
        className: "greyText",
        key: "code",
        order: 1,
        label: "CODE",
        visible: true,
      },
      {
        key: "short_name",
        order: 2,
        label: "SHORT_NAME",
        visible: true,
      },
      {
        className: "greyText separationColumnRight",
        headerClassName: "separationColumnRight",
        key: "name",
        order: 3,
        label: "LONG_NAME",
        visible: true,
      },
      {
        key: "exclude_from_model",
        order: 8,
        label: "EXCLUDE_FROM_MODEL",
        visible: true,
        rules: [
          {
            type: "compare-with",
            value: false,
            operator: "eq",
            options: { color: "text.cell" },
          },
          {
            type: "compare-with",
            value: true,
            operator: "eq",
            options: { color: "text.accent" },
          },
        ],
        type: FormatType.BOOLEAN,
      },
    ],
    filters: [
      {
        type: ConfigurationTableFilterType.Search,
      },
      {
        type: ConfigurationTableFilterType.ResetButton,
      },
    ],
  },
  options: {
    formFields: [
      {
        key: "code",
        label: "CODE",
        type: ConfigurationFormType.Input,
      },
      {
        key: "short_name",
        label: "SHORT_NAME",
        type: ConfigurationFormType.Input,
      },
      {
        key: "name",
        label: "LONG_NAME",
        type: ConfigurationFormType.Input,
      },
      {
        key: "separatorQualification",
        label: "QUALIFICATION",
        type: ConfigurationFormType.Separator,
      },
      {
        key: "exclude_from_model",
        label: "EXCLUDE_FROM_MODEL",
        type: ConfigurationFormType.Check,
      },
    ],
    creatable: false,
    copyable: false,
    editable: true,
    editOptions: [
      {
        key: "code",
        flex: "50%",
        readonly: true,
      },
      {
        key: "short_name",
        flex: "50%",
        readonly: true,
      },
      {
        key: "name",
        flex: "100%",
        readonly: true,
      },
      {
        key: "separatorQualification",
        flex: "100%",
      },
      {
        key: "exclude_from_model",
        flex: "50%",
      },
    ],
    deletable: false,
  },
};

export const SURQUAL_SEGMENT_PAGE = {
  type: ConfigurationPageType.TABS,
  count: 0,
  description: "CONF_PAGE_DESC_DEFAULT",
  label: "SEGMENT",
  pageLabel: "SEGMENT_TITLE_SURQUAL",
  menuLabel: "SEGMENT",
  name: "segment",
  path: "segment",
  tabs: [
    SURQUAL_SEGMENT_PAGE_SEGMENT_TAB,
    SURQUAL_SEGMENT_PAGE_SEGMENT_GROUP1_TAB,
    SURQUAL_SEGMENT_PAGE_SEGMENT_GROUP2_TAB,
    SURQUAL_SEGMENT_PAGE_SEGMENT_NANDC_TAB,
  ],
};
